const WINDOW_SIZE = 7;

function createEllipsis() {
  const el = document.createElement('li');
  el.className = 'dot-ellipsis';
  el.textContent = '···';
  el.setAttribute('aria-hidden', 'true');
  return el;
}

function initCondensedDots(slideshow) {
  const dotList = slideshow.querySelector('.flickity-page-dots');
  if (!dotList) return;

  const dots = [...dotList.querySelectorAll('.dot')];
  const total = dots.length;
  if (total <= WINDOW_SIZE + 2) return;

  const leftEllipsis = createEllipsis();
  const rightEllipsis = createEllipsis();
  dotList.prepend(leftEllipsis);
  dotList.append(rightEllipsis);

  function update() {
    const activeIndex = dots.findIndex(d => d.classList.contains('is-selected'));
    const current = activeIndex === -1 ? 0 : activeIndex;

    const half = Math.floor(WINDOW_SIZE / 2);
    let winStart = Math.max(0, current - half);
    let winEnd   = Math.min(total - 1, current + half);

    if (winEnd - winStart < WINDOW_SIZE - 1) {
      if (winStart === 0) winEnd = Math.min(total - 1, WINDOW_SIZE - 1);
      else winStart = Math.max(0, winEnd - WINDOW_SIZE + 1);
    }

    dots.forEach((dot, i) => {
      const visible = i >= winStart && i <= winEnd;
      dot.style.display = visible ? '' : 'none';
      dot.setAttribute('aria-hidden', String(!visible));
    });

    const leftVisible = winStart > 0;
    leftEllipsis.style.display = leftVisible ? '' : 'none';
    leftEllipsis.setAttribute('aria-label', leftVisible ? `${winStart} more images before` : '');

    const rightVisible = winEnd < total - 1;
    rightEllipsis.style.display = rightVisible ? '' : 'none';
    rightEllipsis.setAttribute('aria-label', rightVisible ? `${total - 1 - winEnd} more images after` : '');
  }

  new MutationObserver(update).observe(dotList, {
    attributes: true,
    subtree: true,
    attributeFilter: ['class']
  });

  update();
}

function init() {
  document.querySelectorAll('.product-slideshow').forEach(initCondensedDots);
}

document.readyState === 'loading'
  ? document.addEventListener('DOMContentLoaded', init)
  : init();

document.addEventListener('shopify:section:load', ({ target }) => {
  target.querySelectorAll('.product-slideshow').forEach(initCondensedDots);
});